'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.adjustValue = undefined;

var _index = require('../type/index');

/**
 * 调整数值
 * @param {Number} value 数据
 * @param {Object} [config] 调整配置
 * @param {Number} [config.min] 最小值
 * @param {Number} [config.max] 最大值
 * @returns {Number} 调整后的数据
 */
var adjustValue = exports.adjustValue = function adjustValue(value) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var min = config.min,
        max = config.max;

    var result = value;

    if ((0, _index.isNumber)(result)) {
        if ((0, _index.isNumber)(min)) {
            if (result < min) {
                result = min;
            }
        }
        if ((0, _index.isNumber)(max)) {
            if (result > max) {
                result = max;
            }
        }
    }

    return result;
}; /**
    * @fileoverview 数字相关
    * @author kirkzheng
    */
exports.default = {
    adjustValue: adjustValue
};